import { useSelector } from 'react-redux';

import { selectCurrentUser } from '@lib/selectors';

export const useCanZoomSquiggly = (): boolean => {
  const currentUser = useSelector(selectCurrentUser);
  if (!currentUser) return false;
  const {
    settings: { telehealth },
    type,
  } = currentUser;
  const hasProviderZoomId = currentUser.telehealthVendors?.zoom?.id;

  if (!hasProviderZoomId || type !== 'doctor') return false;

  const zoomConfig = telehealth?.vendors?.zoom;
  const hasJwtConfigs = !!(zoomConfig?.apiKey && zoomConfig?.apiSecret);
  const hasOAuthConfigs = !!(zoomConfig?.apiAccountId && zoomConfig?.apiClientId);

  return (
    (zoomConfig?.apiAuthMethod === 'jwt' && hasJwtConfigs) || (zoomConfig?.apiAuthMethod === 'oauth' && hasOAuthConfigs)
  );
};
